<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="sales"
      item-key="id"
      hide-default-footer
      class="elevation-1">

      <!-- Columna Total -->
      <template v-slot:item.total="{ item }" class="align-center">
        {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
      </template>

      </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    dates: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      headers: [
        { text: 'Tipo', align: 'left', value: 'paymentMethod', sortable: false },
        { text: 'Total', align: 'left', value: 'total', sortable: false }
        // { text: '%', align: 'center', value: 'percent', sortable: false }
      ],
      sales: [],
      overlay: false
    }
  },
  computed: {
    ...mapGetters(['restaurant'])
  },
  async mounted () {
    await this.getSalesAfterTaxPaymethod()
  },
  methods: {
    async getSalesAfterTaxPaymethod () {
      let [ fromDate ] = this.dates
      this.overlay = true
      try {
        const salesByPayment = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/reports/sales-by-payment`, {
          date: fromDate,
          type: this.period
        })
        this.sales = salesByPayment
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  },
  watch: {
    dates: function () {
      this.getSalesAfterTaxPaymethod()
    },
    period () {
      this.getSalesAfterTaxPaymethod()
    }
  }
}
</script>
